import { useState, useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './Testimonials.css';

gsap.registerPlugin(ScrollTrigger);

const testimonials = [
  {
    quote: 'Ils ont compris notre vision dès le premier rendez-vous. La cuisine livrée dépasse tout ce qu\'on avait imaginé.',
    name: 'Yasmine El Mansouri',
    role: 'Propriétaire villa — Rabat',
    initials: 'YE',
  },
  {
    quote: 'Professionnalisme absolu. Nos bureaux ont été entièrement transformés, dans les délais et avec un résultat haut de gamme.',
    name: 'Mehdi Bennani',
    role: 'Directeur — Casablanca',
    initials: 'MB',
  },
  {
    quote: 'Notre appartement à Marrakech a été métamorphosé. La qualité des matériaux et le souci du détail font vraiment la différence.',
    name: 'Sofia Lahlou',
    role: 'Architecte d\'intérieur',
    initials: 'SL',
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const sectionRef = useRef(null);
  const quoteRef = useRef(null);

  // Auto-rotate every 5s
  useEffect(() => {
    const timer = setInterval(() => {
      setActive(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // Animate quote change
  useEffect(() => {
    if (!quoteRef.current) return;
    gsap.fromTo(quoteRef.current,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.6, ease: 'power3.out' }
    );
  }, [active]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(sectionRef.current,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  const t = testimonials[active];

  return (
    <section className="testi-section" ref={sectionRef}>
      <div className="testi-container">

        {/* Large decorative quote mark */}
        <div className="testi-quote-mark">"</div>

        {/* Quote content */}
        <div className="testi-content" ref={quoteRef} key={active}>
          <blockquote className="testi-quote">{t.quote}</blockquote>

          <div className="testi-author">
            <div className="testi-avatar">{t.initials}</div>
            <div className="testi-author-info">
              <span className="testi-name">{t.name}</span>
              <span className="testi-role">{t.role}</span>
            </div>
          </div>
        </div>

        {/* Navigation dots */}
        <div className="testi-dots">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`testi-dot ${i === active ? 'testi-dot--active' : ''}`}
              onClick={() => setActive(i)}
              aria-label={`Témoignage ${i + 1}`}
            />
          ))}
        </div>

        {/* Stars */}
        <div className="testi-stars" style={{ display: 'flex', gap: '6px', justifyContent: 'center', marginTop: '24px' }}>
          {[...Array(5)].map((_, i) => (
            <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="var(--gold)" stroke="var(--gold)" strokeWidth="1">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          ))}
        </div>

      </div>
    </section>
  );
}
